import { render, staticRenderFns } from "./M2hError.vue?vue&type=template&id=18e700aa&scoped=true&"
import script from "./M2hError.vue?vue&type=script&lang=js&"
export * from "./M2hError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e700aa",
  null
  
)

export default component.exports